module.exports = __webpack_public_path__ + "img/picture_34.6de8dccc.png";